import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { Logo } from "@/components/ui/logo";

/**
 * Provisional scaffold home (F0a): brand + product promise.
 * F0b replaces it with the congregation tree / church panel.
 * Local-first and query-free: renders synchronously with the shell.
 */
function HomePage() {
  return (
    <div class="flex flex-1 flex-col items-center justify-center gap-6 p-8 text-center">
      <Logo size="lg" />
      <p class="max-w-md text-balance text-muted" data-testid="home-tagline">
        The operating system for your church: people, congregations, groups, gatherings and
        projection — local-first and offline.
      </p>
    </div>
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: HomePage,
});
